<template>
  <span class="multiselector-moeda">
    <multiselect
      v-model="selected"
      @input="onChange"
      :options="options"
      :custom-label="label"
      selectLabel=""
      selectedLabel="«"
      deselectLabel=""
      :allowEmpty="allowEmpty"
      :preselectFirst="true"
      :loading="isLoading"
      :multiple="multiple"
      :label="$t('Nome')"
      track-by="id"
      :disabled="isDisabled"
      :hide-selected="true"
      placeholder=""
      class="mutiselect-primary"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <div class="flag-option">
          <flag :iso="option.iso2" :squared="false" />
          <span class="flag-text">{{ option.id }}</span>
        </div>
      </template>
      <template slot="option" slot-scope="{ option }">
        <div class="flag-option">
          <flag :iso="option.iso2" :squared="false" />
          <span class="flag-text">{{ option.id }}</span>
        </div>
      </template>
      <template slot="noResult">
        <span>{{ $t('Nenhum elemento encontrado') }}.</span>
      </template>
      <template slot="noOptions">
        <span>{{ $t('Nenhum dado foi retornado') }}.</span>
      </template>
      <template slot="placeholder">
        <span>{{ $t(emptyLabel) }}</span>
      </template>
      <template slot="tag" slot-scope="{ option, remove }" class="d-flex">
        <span class="multiselect__tag bg-primary">
          <flag :iso="option.iso2" :squared="false" />
          <span>{{ option.id }} </span>
          <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
        </span>
      </template>
    </multiselect>
  </span>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'posicao',
    'multiple',
    'allowEmpty'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false,
      currencyPriorityMap: {
        USD: 'us', // Dólar dos Estados Unidos
        EUR: 'de', // Euro da Alemanha
        GBP: 'gb', // Libra Esterlina do Reino Unido
        JPY: 'jp', // Iene do Japão
        CAD: 'ca', // Dólar Canadense
        AUD: 'au', // Dólar Australiano
        CHF: 'ch', // Franco Suíço
        CNY: 'cn', // Yuan da China
        BRL: 'br', // Real do Brasil
        INR: 'in', // Rúpia Indiana
        RUB: 'ru', // Rublo Russo
        ZAR: 'za', // Rand da África do Sul
        MXN: 'mx', // Peso Mexicano
        ARS: 'ar', // Peso Argentino
        CLP: 'cl', // Peso Chileno
        NZD: 'nz', // Dólar Neozelandês
        KRW: 'kr', // Won da Coreia do Sul
        SEK: 'se', // Coroa Sueca
        NOK: 'no', // Coroa Norueguesa
        TRY: 'tr' // Lira Turca
      }
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (this.multiple === true) {
        this.$emit('selectChange', 'moedas', e);
        return;
      }
      if (e == null) {
        this.$emit('selectChange', 'moedaPadrao', null);
        return;
      }
      if (this.posicao != undefined) {
        this.$emit('selectChange', 'moedaPadrao', { e: e.id, index: this.posicao });
      } else {
        this.$emit('selectChange', 'moedaPadrao', e.id);
      }
    },
    label({ nome }) {
      return nome;
    },
    setValue(value) {
      if (this.multiple === true) {
        if (value) {
          this.selected = this.options.filter((option) => value.split(',').includes(option.id));
        }
        return;
      }

      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('paises', {
          columns: 'nome,detalhes,iso2',
          order: 'nome'
        })
        .then((res) => {
          const uniqueCurrencies = new Map();

          res.data.forEach((item) => {
            const currencyCode = JSON.parse(item?.detalhes || '{}')['iso-4217'];
            const iso2 = item.iso2;
            const priorityIso2 = this.currencyPriorityMap[currencyCode];

            if (!uniqueCurrencies.has(currencyCode) || (priorityIso2 && priorityIso2 === iso2)) {
              uniqueCurrencies.set(currencyCode, {
                id: currencyCode,
                nome: currencyCode,
                iso2: priorityIso2 || iso2
              });
            }
          });

          this.options = Array.from(uniqueCurrencies.values()).sort((a, b) => a.nome.localeCompare(b.nome));

          if (this.includeAll) {
            this.options.unshift({ id: null, nome: this.$i18n.t(this.emptyLabel) });
          }

          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss">
.multiselector-moeda {
  .flag-option {
    display: flex;
    align-items: center;
  }
  .flag-text {
    margin-left: 8px;
  }
  .multiselect__tags-wrap {
    display: flow-root !important;
  }
}
</style>
